import { render } from "./AccountSection.vue?vue&type=template&id=54b9737c"
import script from "./AccountSection.vue?vue&type=script&lang=js"
export * from "./AccountSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__